/* eslint-disable no-undef */
export function vibrate(milliseconds = 8) {
  navigator.vibrate =
    navigator.vibrate ||
    navigator.webkitVibrate ||
    navigator.mozVibrate ||
    navigator.msVibrate;

  if (navigator.vibrate) {
    navigator.vibrate(milliseconds);
  }
}
